import type { Plugin } from 'vue'

// Styles (fonts, icons, basic styles)
import '@quasar/extras/roboto-font-latin-ext/roboto-font-latin-ext.css'
import '@quasar/extras/material-icons/material-icons.css'

import 'quasar/src/css/index.sass'

import '/node_modules/flag-icons/css/flag-icons.min.css'

// Quasar
import { Quasar, Dialog, Notify, AppFullscreen, Loading } from 'quasar'
import quasarLang from 'quasar/lang/cs'
import qDraggableTable from 'quasar-ui-q-draggable-table'
import 'quasar-ui-q-draggable-table/dist/index.css'
import '@/css/app.sass'

export const viewlayer: Plugin = (app) => {
    app.use(Quasar, {
        plugins: {
            Dialog,
            Notify,
            AppFullscreen,
            Loading,
        },
        lang: quasarLang,
    }).use(qDraggableTable)
}
